import React, { useState, useEffect } from 'react';
import styles from './Exams.module.css';
import { stages } from '../../../data/studentsData';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../../api/client';
import { formatCairoDate } from '../../../utils/cairoDate';

const Exams = () => {
  const navigate = useNavigate();
  const [selectedStage, setSelectedStage] = useState('');
  const [exams, setExams] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchExams = async () => {
    try {
      const { data } = await apiClient.get('/exams');
      setExams(data);
    } catch (error) {
      console.error("❌ مشكلة في جلب الامتحانات:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchExams();
  }, []);

  const handleDelete = async (examId) => {
    if (!window.confirm('متأكد إنك عايز تحذف الامتحان ده؟')) return;
    try {
      await apiClient.delete(`/exams/${examId}`);
      setExams(exams.filter(e => e._id !== examId));
    } catch (error) {
      alert('حصل خطأ أثناء الحذف');
    }
  };

  const filteredExams = selectedStage
    ? exams.filter(exam => exam.stage === selectedStage)
    : exams;

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.header}>
        <h1 className={styles.title}>إدارة الامتحانات</h1>
       <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
         <button className={styles.addBtn} onClick={() => navigate('/create-exam')}>
          + إنشاء امتحان جديد
          </button>
         <button className={styles.addBtn} style={{ backgroundColor: '#0ea5e9' }} onClick={() => navigate('/monthly-report')}>
          📈 تقرير الشهر الكامل
          </button>
       </div>
      </div>

      <div className={styles.filtersContainer}>
        <select
          className={styles.selectBox}
          value={selectedStage}
          onChange={(e) => setSelectedStage(e.target.value)}
        >
          <option value="">كل المراحل الدراسية</option>
          {stages.map((stage, index) => (
            <option key={index} value={stage}>{stage}</option>
          ))}
        </select>
      </div>

      <div className={styles.examsGrid}>
        {loading ? (
          <div style={{ textAlign: 'center', color: '#6b7280', padding: '2rem', gridColumn: '1 / -1' }}>
            جاري التحميل...
          </div>
        ) : filteredExams.length > 0 ? (
          filteredExams.map(exam => (
            <div key={exam._id} className={styles.examCard}>
              <div className={styles.examHeader}>
                <div>
                  <h3 className={styles.examTitle}>{exam.name}</h3>
                  <span className={styles.examType}>{exam.type}</span>
                </div>
              </div>

              <div className={styles.examDetail}>
                <span>📚</span> {exam.stage}
              </div>
              <div className={styles.examDetail}>
                <span>📅</span> {formatCairoDate(exam.date)}
              </div>
              <div className={styles.examDetail}>
                <span>❓</span> عدد الأسئلة: {exam.questions?.length || 0}
              </div>

              <button
                className={styles.actionBtn}
                onClick={() => navigate(`/exam-results/${exam._id}`)}
                >
                عرض النتائج والتفاصيل
               </button>

              <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.5rem' }}>
                <button
                  className={styles.actionBtn}
                  style={{ backgroundColor: '#2563eb' }}
                  onClick={() => {
                    navigator.clipboard.writeText(`${window.location.origin}/solve-exam/${exam._id}`);
                    alert('تم نسخ رابط الامتحان! ابعته للطلاب 🎉');
                  }}
                >
                  🔗 نسخ رابط الامتحان
                </button>
                <button
                  className={styles.actionBtn}
                  style={{ backgroundColor: '#dc2626' }}
                  onClick={() => handleDelete(exam._id)}
                >
                  🗑️ حذف
                </button>
              </div>
            </div>
          ))
        ) : (
          <div style={{ textAlign: 'center', color: '#6b7280', padding: '2rem', gridColumn: '1 / -1' }}>
            لا توجد امتحانات مسجلة لهذه المرحلة حالياً
          </div>
        )}
      </div>
    </div>
  );
};

export default Exams;
